import { ActionContext, ActionTree } from "vuex";
import { RootState } from "@/store/types";
import { ThemeConfig } from "@/plugins/config";

type RootActionContext = ActionContext<RootState, RootState>;
type RootActionTree = ActionTree<RootState, RootState>;

export const actions: RootActionTree = {
  async setOnline(context: RootActionContext, payload: boolean): Promise<void> {
    context.commit("setOnline", payload);
  },

  async setCurrentTheme(
    context: RootActionContext,
    payload: ThemeConfig
  ): Promise<any> {
    context.commit("setCurrentTheme", payload);
  },
};
